/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* Accessibility hardening for dynamic Prestige UI. */
(function () {
  'use strict';

  function text(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function labelDynamicControls(root) {
    root = root || document;

    root.querySelectorAll('svg').forEach(function (svg) {
      if (!svg.hasAttribute('aria-label') && !svg.hasAttribute('aria-labelledby') && !svg.querySelector('title')) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    });

    root.querySelectorAll('iframe:not([title])').forEach(function (frame) {
      frame.setAttribute('title', 'Embedded content');
    });

    root.querySelectorAll('[role="dialog"]').forEach(function (dialog) {
      dialog.setAttribute('aria-modal', 'true');
    });

    root.querySelectorAll('button:not([aria-label]):not([aria-labelledby])').forEach(function (button) {
      if (text(button)) return;
      var action = button.getAttribute('data-action') || '';
      var cls = button.className || '';
      var label = '';
      if (/close/.test(action) || /Close/.test(cls)) label = 'Close';
      else if (/open-product-zoom/.test(action)) label = 'Zoom product image';
      else if (/toggle-social-share/.test(action)) label = 'Share product';
      else if (/previous|prev/i.test(action + ' ' + cls)) label = 'Previous';
      else if (/next/i.test(action + ' ' + cls)) label = 'Next';
      else if (/search/i.test(action + ' ' + cls)) label = 'Search';
      else if (/cart/i.test(action + ' ' + cls)) label = 'Cart';
      if (label) button.setAttribute('aria-label', label);
    });

    root.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = link.getAttribute('rel') || '';
      if (!/\bnoopener\b/.test(rel)) link.setAttribute('rel', (rel + ' noopener').trim());
    });
  }


  var lastLauncher = null;

  function rememberLauncher(event) {
    var target = event.target && event.target.closest ? event.target : null;
    var launcher = target ? target.closest('[data-action="open-drawer"], [data-action="open-modal"], [data-action="toggle-search"]') : null;
    if (launcher) lastLauncher = launcher;
  }

  function syncDrawerState(drawer) {
    if (!drawer || !drawer.id) return;
    var expanded = drawer.getAttribute('aria-hidden') === 'false' ? 'true' : 'false';
    document.querySelectorAll('[data-drawer-id="' + drawer.id + '"]').forEach(function (control) {
      if (control.getAttribute('data-action') === 'open-drawer') {
        control.setAttribute('aria-controls', drawer.id);
        control.setAttribute('aria-expanded', expanded);
      }
    });
    if (expanded === 'false' && lastLauncher && lastLauncher.getAttribute('data-drawer-id') === drawer.id) {
      lastLauncher.focus();
      lastLauncher = null;
    }
  }

  function syncDialogFocus(dialog) {
    if (!dialog) return;
    if (dialog.getAttribute('aria-hidden') === 'true' && lastLauncher) {
      var controls = lastLauncher.getAttribute('aria-controls');
      if (controls === dialog.id || (dialog.id === 'Search' && lastLauncher.matches('[data-action="toggle-search"]'))) {
        lastLauncher.focus();
        lastLauncher = null;
      }
    }
  }

  function enhanceFaq(root) {
    (root || document).querySelectorAll('.Faq__Question[aria-controls]').forEach(function (button) {
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      var item = button.closest('.Faq__Item');
      var expanded = (item && item.getAttribute('aria-expanded') === 'true') || panel.getAttribute('aria-hidden') === 'false';
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function enhanceTimeline(root) {
    (root || document).querySelectorAll('.Timeline').forEach(function (timeline) {
      var tabs = Array.prototype.slice.call(timeline.querySelectorAll('.Timeline__NavItem[role="tab"]'));
      if (!tabs.length || timeline.dataset.a11yKeyboard === 'true') return;
      timeline.dataset.a11yKeyboard = 'true';
      function sync() {
        tabs.forEach(function (tab) {
          var selected = tab.classList.contains('is-selected');
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
      }
      timeline.addEventListener('click', function () { window.setTimeout(sync, 0); });
      tabs.forEach(function (tab, index) {
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            event.preventDefault();
            tabs[next].click();
            tabs[next].focus();
          }
        });
      });
      sync();
    });
  }

  function enhanceTestimonials(root) {
    (root || document).querySelectorAll('.TestimonialNav').forEach(function (nav) {
      var items = Array.prototype.slice.call(nav.querySelectorAll('.TestimonialNav__Item'));
      if (!items.length || nav.dataset.a11yKeyboard === 'true') return;
      nav.dataset.a11yKeyboard = 'true';
      function sync() {
        items.forEach(function (item) {
          var selected = item.classList.contains('is-selected');
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
        });
      }
      nav.addEventListener('click', function () { window.setTimeout(sync, 0); });
      items.forEach(function (item, index) {
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); item.click(); return;
          }
          var next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % items.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + items.length) % items.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = items.length - 1;
          if (next !== null) {
            event.preventDefault(); items[next].click(); items[next].focus();
          }
        });
      });
      sync();
    });
  }

  function enhanceInstagram(root) {
    (root || document).querySelectorAll('.Instafeed__Cell').forEach(function (cell, index) {
      var link = cell.matches('a') ? cell : cell.querySelector('a');
      if (!link || link.hasAttribute('aria-label')) return;
      var caption = cell.querySelector('.Instafeed__Caption');
      var captionText = caption ? text(caption) : '';
      link.setAttribute('aria-label', captionText ? 'Instagram: ' + captionText : 'View Instagram post ' + (index + 1));
    });
  }

  function syncSearchState() {
    var search = document.getElementById('Search');
    if (!search) return;
    var expanded = search.getAttribute('aria-hidden') === 'false' ? 'true' : 'false';
    document.querySelectorAll('[data-action="toggle-search"], [data-action="open-search"]').forEach(function (control) {
      control.setAttribute('aria-controls', 'Search');
      control.setAttribute('aria-expanded', expanded);
    });
  }


  function enhanceAccessibleNewsletterPopup(root) {
    (root || document).querySelectorAll('[data-section-type="newsletter-popup-accessible"]').forEach(function (dialog) {
      if (dialog.dataset.a11yPopup === 'true') return;
      dialog.dataset.a11yPopup = 'true';
      var close = dialog.querySelector('[data-action="close-popup"]');
      var previousFocus = null;

      function focusables() {
        return Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
      }
      function open() {
        previousFocus = document.activeElement;
        dialog.setAttribute('aria-hidden', 'false');
        var page = document.querySelector('.PageContainer');
        if (page) { page.setAttribute('inert', ''); page.setAttribute('aria-hidden', 'true'); }
        var items = focusables();
        (items[0] || dialog).focus();
      }
      function closePopup() {
        dialog.setAttribute('aria-hidden', 'true');
        var page = document.querySelector('.PageContainer');
        if (page) { page.removeAttribute('inert'); page.removeAttribute('aria-hidden'); }
        if (previousFocus && previousFocus.focus) previousFocus.focus();
      }
      if (close) close.addEventListener('click', function (event) { event.preventDefault(); closePopup(); });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); closePopup(); return; }
        if (event.key !== 'Tab') return;
        var items = focusables();
        if (!items.length) { event.preventDefault(); dialog.focus(); return; }
        var first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });

      // Do not interrupt a first visit. The popup opens only when explicitly deep-linked.
      if (window.location.hash === '#newsletter-popup' || window.location.hash === '#' + dialog.id) open();
    });
  }

  function enhanceSlideshowAccessibility(root) {
    (root || document).querySelectorAll('.Slideshow__Carousel, .Product__Slideshow, .TestimonialList').forEach(function (carousel) {
      function flkty() {
        return carousel.flickityInstance || (window.Flickity && Flickity.data && Flickity.data(carousel));
      }
      function focusables(node) {
        return Array.prototype.slice.call(node.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'));
      }
      function syncSlides() {
        var f = flkty();
        if (f) {
          f.options.accessibility = false;
          if (f.viewport) f.viewport.setAttribute('tabindex', '-1');
        }
        carousel.setAttribute('tabindex', '-1');
        carousel.querySelectorAll('.flickity-page-dots').forEach(function (dots) {
          dots.setAttribute('role', 'group');
          dots.setAttribute('aria-label', 'Choose slide');
        });
        var pageDots = carousel.querySelectorAll('.flickity-page-dots .dot');
        pageDots.forEach(function (el, index) {
          el.removeAttribute('role');
          el.removeAttribute('aria-label');
          el.removeAttribute('data-sb-keyboard-dot');
          el.setAttribute('tabindex', '-1');
          var btn = el.querySelector('button');
          if (!btn) {
            btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'SlideshowDot';
            el.appendChild(btn);
            btn.addEventListener('click', function (e) { e.stopPropagation(); el.click(); });
          }
          btn.setAttribute('aria-label', 'Go to slide ' + (index + 1) + ' of ' + pageDots.length);
          btn.setAttribute('tabindex', '-1');
          if (el.classList.contains('is-selected')) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        });
        carousel.querySelectorAll('.flickity-prev-next-button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        var cells = [];
        if (f && f.cells && f.cells.length) {
          cells = f.cells.map(function (cell) { return cell.element; });
        } else {
          cells = Array.prototype.slice.call(carousel.querySelectorAll('.Slideshow__Slide, .Carousel__Cell, .Product__Slide, .Testimonial'));
        }
        var selectedIndex = (f && typeof f.selectedIndex === 'number') ? f.selectedIndex : 0;
        if (cells.length === 1) selectedIndex = 0;
        cells.forEach(function (cell, index) {
          var selected = index === selectedIndex || cells.length === 1;
          cell.setAttribute('aria-hidden', selected ? 'false' : 'true');
          focusables(cell).forEach(function (el) {
            if (el.closest('.flickity-prev-next-button, .flickity-page-dots')) return;
            if (selected) {
              el.removeAttribute('tabindex');
              el.removeAttribute('data-sb-tab');
            } else {
              el.setAttribute('tabindex', '-1');
              el.setAttribute('data-sb-tab', '-1');
            }
          });
        });
      }
      syncSlides();
      if (carousel.dataset.a11yCarousel === 'true') return;
      carousel.dataset.a11yCarousel = 'true';
      var f = flkty();
      if (f && f.on) f.on('select', function () { window.setTimeout(syncSlides, 0); });
      carousel.addEventListener('click', function () { window.setTimeout(syncSlides, 0); });
      if ('MutationObserver' in window) new MutationObserver(syncSlides).observe(carousel, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }

  function enhanceFilterLabels() {
    var map = window.SB_FILTER_LABELS || {};
    document.querySelectorAll('[data-action="toggle-tag"]').forEach(function (btn) {
      var raw = (btn.getAttribute('data-tag') || '').trim();
      var key = raw.replace(/^rolex-reference-/, '');
      var label = map[key] || map[key.toUpperCase()] || map[key.toLowerCase()];
      if (!label) {
        var text = (btn.textContent || '').replace(/^\s+|\s+$/g, '');
        var m = text.match(/(\d{5,6}[A-Za-z]{0,3})/);
        if (m) label = map[m[1]] || map[m[1].toUpperCase()] || map[m[1].toLowerCase()];
      }
      if (label && btn.getAttribute('data-sb-label') !== '1') {
        btn.setAttribute('data-sb-label', '1');
        btn.textContent = label;
        btn.setAttribute('aria-label', 'Filter: ' + label);
        btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
      }
    });
  }

  function enhanceKnownImageAlts() {
    var alts = {
      wesellwatches5: 'Sant Blanc purchases luxury Swiss timepieces',
      'warranty-web-picture2': 'Sant Blanc warranty information',
      'screen_shot_2019-10-03': 'Historical Rolex workshop photograph from Sant Blanc history'
    };
    document.querySelectorAll('img').forEach(function (img) {
      var current = img.getAttribute('alt');
      if (current && current.trim()) return;
      var src = ((img.getAttribute('src') || '') + ' ' + (img.getAttribute('data-src') || '')).toLowerCase();
      Object.keys(alts).forEach(function (key) {
        if (src.indexOf(key) !== -1) img.setAttribute('alt', alts[key]);
      });
    });
  }

  function enhanceHeaderOffset() {
    function measure() {
      var bar = document.getElementById('shopify-section-announcement');
      var header = document.getElementById('shopify-section-header');
      var h = 16;
      if (bar) h += bar.offsetHeight || 0;
      if (header) h += header.offsetHeight || 0;
      document.documentElement.style.setProperty('--sb-header-offset', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
  }

  function enhanceBackToTop() {
    var btn = document.querySelector('[data-action="back-to-top"]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var skip = document.querySelector('.PageSkipLink');
      if (skip) skip.focus();
    });
  }

  function enhanceInjectedSocialLinks(root) {
    var patterns = [
      ['facebook.com', 'Sant Blanc on Facebook'],
      ['instagram.com', 'Sant Blanc on Instagram'],
      ['youtube.com', 'Sant Blanc on YouTube'],
      ['wa.me', 'Contact Sant Blanc on WhatsApp'],
      ['whatsapp.com', 'Contact Sant Blanc on WhatsApp']
    ];
    (root || document).querySelectorAll('a[href]').forEach(function (link) {
      if (link.hasAttribute('aria-label') || text(link)) return;
      var href = (link.getAttribute('href') || '').toLowerCase();
      patterns.some(function (pair) {
        if (href.indexOf(pair[0]) !== -1) { link.setAttribute('aria-label', pair[1]); return true; }
        return false;
      });
    });
  }


  function syncPopoverStates(root) {
    (root || document).querySelectorAll('.Popover[id]').forEach(function (popover) {
      var control = document.querySelector('[aria-controls="' + popover.id + '"]');
      if (!control) return;
      var expanded = popover.getAttribute('aria-hidden') === 'false';
      control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (popover.dataset.a11yPopoverObserved === 'true' || !('MutationObserver' in window)) return;
      popover.dataset.a11yPopoverObserved = 'true';
      new MutationObserver(function () {
        var open = popover.getAttribute('aria-hidden') === 'false';
        control.setAttribute('aria-expanded', open ? 'true' : 'false');
      }).observe(popover, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  function announceProductAdded() {
    var region = document.getElementById('A11yCartStatus');
    if (!region) {
      region = document.createElement('div');
      region.id = 'A11yCartStatus';
      region.className = 'u-visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    document.addEventListener('product:added', function () {
      region.textContent = '';
      window.setTimeout(function () { region.textContent = 'Item added to cart.'; }, 20);
    });
  }

  function enhanceHeaderMenuKeys() {
    var nav = document.querySelector('.Header__MainNav');
    if (!nav) return;
    function setOpen(item, open) {
      var menu = item.querySelector('.MegaMenu, .DropdownMenu');
      var trigger = item.querySelector(':scope > a');
      item.classList.toggle('is-expanded', open);
      if (menu) menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) {
      nav.querySelectorAll('.HorizontalList__Item.is-expanded').forEach(function (item) {
        if (item !== except) setOpen(item, false);
      });
    }
    nav.addEventListener('keydown', function (event) {
      var item = event.target.closest('.HorizontalList__Item');
      if (!item || !nav.contains(item)) return;
      if (!item.querySelector('.MegaMenu, .DropdownMenu')) return;
      if ((event.key === 'Enter' || event.key === ' ') && !event.target.closest('.MegaMenu, .DropdownMenu')) {
        event.preventDefault();
        var open = !item.classList.contains('is-expanded');
        closeAll(item);
        setOpen(item, open);
      }
      if (event.key === 'Escape') {
        setOpen(item, false);
        var top = item.querySelector(':scope > a');
        if (top) top.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) closeAll();
    });
  }




  function enhanceFormA11y(root) {
    (root || document).querySelectorAll("input, select, textarea").forEach(function (el) {
      if (el.required) el.setAttribute("aria-required", "true");
      if (el.getAttribute("aria-invalid") === null) el.setAttribute("aria-invalid", "false");
      el.addEventListener("invalid", function () { el.setAttribute("aria-invalid", "true"); });
      el.addEventListener("input", function () { if (el.validity && el.validity.valid) el.setAttribute("aria-invalid", "false"); });
    });
  }

  function init() {
    labelDynamicControls(document);
    syncSearchState();
    enhanceFaq(document);
    enhanceTimeline(document);
    enhanceTestimonials(document);
    enhanceInstagram(document);
    enhanceAccessibleNewsletterPopup(document);
    enhanceSlideshowAccessibility(document);
    enhanceInjectedSocialLinks(document);
    syncPopoverStates(document);
    announceProductAdded();
    enhanceHeaderOffset();
    enhanceHeaderMenuKeys();
    enhanceBackToTop();
    enhanceKnownImageAlts();
    enhanceFormA11y(document);
    enhanceFilterLabels();
    document.addEventListener('click', rememberLauncher, true);
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('.Faq__Question')) {
        window.setTimeout(function () { enhanceFaq(document); }, 0);
      }
    });
    document.querySelectorAll('.Drawer').forEach(syncDrawerState);
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { labelDynamicControls(node); enhanceFaq(node); enhanceTimeline(node); enhanceTestimonials(node); enhanceInstagram(node); enhanceAccessibleNewsletterPopup(node); enhanceSlideshowAccessibility(node); enhanceInjectedSocialLinks(node); syncPopoverStates(node); enhanceFilterLabels(); }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });

      document.querySelectorAll('.Drawer, [role="dialog"]').forEach(function (widget) {
        var stateObserver = new MutationObserver(function () {
          if (widget.classList.contains('Drawer')) syncDrawerState(widget);
          syncDialogFocus(widget);
        });
        stateObserver.observe(widget, { attributes: true, attributeFilter: ['aria-hidden'] });
      });

      var search = document.getElementById('Search');
      if (search) {
        var searchObserver = new MutationObserver(syncSearchState);
        searchObserver.observe(search, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest && e.target.closest('.ProductItem__ImageWrapper');
    if (!wrap) return;
    var card = wrap.closest('.ProductItem');
    var link = card && card.querySelector('.ProductItem__Title a');
    if (link) link.click();
  });
